module.exports = __webpack_public_path__ + "img/sintesis.86f94d8a.svg";